/**
 * Modal window directive for Edit functionality
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmCommonAssetRow', [function () {
    return {
      restrict: 'E',
      scope: {
        asset: '=?',
        isHeader: '=?',
        collection: '=?',
        index: '=?',
        isEdit: '@?'
      },
      replace: true,
      link: function (scope, element, attrs, ngModel) {
      },
      controller: 'CommonAssetRowController',
      templateUrl: 'lm-table-rows/common-asset-row/common-asset-row.tpl.html'
    };
  }]);
lmApp
  .controller('CommonAssetRowController', ['$scope', '$rootScope', '$templateCache', '$compile', 'AssetService', 'MetadataService', 'ModalWindowService',
    function ($scope, $rootScope, $templateCache, $compile, AssetService, MetadataService, ModalWindowService) {
      if ($scope.isHeader) return;

      if (!$scope.collection) $scope.collection = [$scope.asset];

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      $scope.getType = function (asset) {

        switch (true) {
          case asset.type === 'channel':
            return 'channel';
            break;

          case asset.type === 'package' && asset.package_type === 'tv_series':
            return 'tv_series';
            break;

          case asset.type === 'movie' && !!asset.tv_series_episode:
            return 'tv_episode';
            break;

          case asset.type === 'movie':
            return 'movie';
            break;

          default:
            return asset.type;
            break
        }
      };

      $scope.getAssetType = function (asset) {
        switch (true) {
          case asset.type === 'channel':
            return 'Channel';
            break;

          case asset.type === 'package' && asset.package_type === 'tv_series':
            return 'TV Series';
            break;

          case asset.type === 'package':
            return 'Package';
            break;

          case asset.type === 'movie':
            return 'Movie';
            break;
        }
      };


      $scope.asset.uiType = $scope.getAssetType($scope.asset);

      $scope.asset.type = $scope.getType($scope.asset);

      $scope.status = {};

      $scope.assetWatcher = $scope.$watchCollection('asset', function(newValue, oldValue) {

        $scope.asset.uiType = $scope.getAssetType($scope.asset);

        $scope.asset.type = $scope.getType($scope.asset);

        if (newValue) AssetService.GetPoster(newValue)
          .then(function (url) {
            $scope.posterData = {
              url: url,
              t: _.get(_.find(newValue.resources, {type: 'picture'}), 'uptime_time') || Date.now()
            }
          });

        $scope.status._deployed = {
          stream: newValue.resources.filter(function (resource) {
            return resource.type === 'stream' && resource.stream_type !== 'hls_catchup';
          }).map(function (resource) {
            if (resource.stream_type.indexOf('youtube') !== -1) {
              $scope.asset._has_youtube = true;
              resource.stream_type = 'youtube';
              resource._stream_sub_type = 'y';
            }

            resource._stream_type = $scope._STREAM_TYPES_ATTRS[resource.stream_type];

            if (resource.category) resource._stream_sub_type = resource.category[0];

            return resource;
          }),
          poster: _.find(newValue.resources, {category: 'poster_blueprint'}) && _.find(newValue.resources, {category: 'poster_blueprint'}).is_deployed
        };

        $scope.status._rentalStatus = newValue.rental_status === "progress";
        if (!$scope.status._rentalStatus) {
          $scope.status._rentalWindow = MetadataService.Rental.Check(newValue);
        }

      });

      if (!$scope.isEdit) return;

      $scope.openModal = function (assetData, e) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        if (assetData.type === 'package') return;

        var modalScope = $rootScope.$new();

        modalScope.currentFocused = $scope.index || -1;
        modalScope.localCollection = $scope.collection || [];

        modalScope.asset = angular.copy(assetData);
        modalScope.asset._PrivateData = {};

        modalScope.loading = false;

        modalScope.processAsset = function (asset) {
          if (modalScope.loading) return;

          modalScope.updateFn(asset, modalScope.currentFocused)
            .then(function () {
              AssetService.GetAssetById($scope.asset.id)
                .then(function (collection) {
                  if (collection.length) {
                    var t = $scope.asset._PrivateData;
                    $scope.asset = collection[0];
                    $scope.asset.uiType = $scope.getAssetType($scope.asset);
                    $scope.asset.type = $scope.getType($scope.asset);
                    $scope.asset._PrivateData = t;
                  }
                });
            });
        };

        modalScope.setCurrentQuality = function (asset, value) {
          MetadataService.Quality.SetValue(asset, value);
        };

        modalScope.isFirst = function () {
          return !modalScope.currentFocused;
        };

        modalScope.isLast = function () {
          return modalScope.localCollection && modalScope.currentFocused === modalScope.localCollection.length - 1;
        };

        modalScope.close = function () {
          if (modalScope.loading) return;

          modalScope.fullscreenToogle(false);
          ModalWindowService.Close($scope.window, false);
        };

        modalScope.fullscreenToogle = function (state) {
          if (typeof state !== 'undefined') {
            modalScope.fullscreen = state;
          } else {
            modalScope.fullscreen = !modalScope.fullscreen;
          }

          ModalWindowService.Fullscreen($scope.window, state);
        };

        modalScope._modalWindow_ = $templateCache.get('lm-assets-edit/edit-window.tpl.html');

        modalScope._modalWindow_ = $compile(modalScope._modalWindow_)(modalScope);

        $scope.window = ModalWindowService.Open({
          content: modalScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-assets-edit/navigation-buttons.tpl.html'))(modalScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          }
        });

        modalScope._modalWindow_.on('$destroy', function () {
          modalScope.$destroy();
        });
      };

      $scope.$on('$destroy', function () {
        $scope.assetWatcher();
      });
    }]);
